module.exports = __webpack_public_path__ + "img/11-half-md.f7f99977.jpg";